export enum JobTypes {
  SINGULAR = 'SINGULAR',
  RECURRING = 'RECURRING',
}
